import { css } from "@compiled/react";

import Spinner from "@atlaskit/spinner";

export const LoadingSpinner = () => (
    <div
        css={css({
            display: "flex",
            justifyContent: "center",
            height: "600px",
            alignItems: "center"
        })}
    >
        <div
            role="alert"
            aria-label="Loading"
            data-testid="global-nav-user-profile-container-spinner"
        >
            <Spinner />
        </div>
    </div>
);
